<script lang="ts" setup>
import { useCurrentUser } from '@/composables/useCurrentUser'
import navItemsBase from '@/navigation/horizontal'
import { filterNavForSuperAdmin } from '@/utils/navItems'
import { computed } from 'vue'

import { themeConfig } from '@themeConfig'

// Components
import AdminPanelMenu from '@/layouts/components/AdminPanelMenu.vue'
import Footer from '@/layouts/components/Footer.vue'
import UserProfile from '@/layouts/components/UserProfile.vue'
import NavBarI18n from '@core/components/I18n.vue'
import { HorizontalNavLayout } from '@layouts'
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import SubscriptionBadge from './SubscriptionBadge.vue'

const { isAdmin } = useCurrentUser()
const navItems = computed(() => filterNavForSuperAdmin(navItemsBase, isAdmin.value))
</script>

<template>
  <HorizontalNavLayout :nav-items="navItems">
    <!-- 👉 navbar -->
    <template #navbar>
      <NuxtLink
        to="/"
        class="app-logo d-flex align-center gap-x-3"
      >
        <VNodeRenderer :nodes="themeConfig.app.logo" />

      </NuxtLink>
      <VSpacer />

      <NavBarI18n
        v-if="themeConfig.app.i18n.enable && themeConfig.app.i18n.langConfig?.length"
        :languages="themeConfig.app.i18n.langConfig"
      />

      <AdminPanelMenu class="me-2" />
      <SubscriptionBadge class="me-2" />
      <UserProfile />
    </template>

    <!-- 👉 Pages -->
    <slot />

    <!-- 👉 Footer -->
    <template #footer>
      <Footer />
    </template>

    <!-- 👉 Customizer -->
    <!-- <TheCustomizer /> -->
  </HorizontalNavLayout>
</template>
